import { render } from "./App.vue?vue&type=template&id=1bccd117&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1bccd117&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Ray Wang\\Desktop\\tubertrader\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bccd117"]])

export default __exports__